import React from 'react';
import { Link } from 'react-router-dom';
import { Check } from 'lucide-react';

const Pricing = () => {
    return (
        <div className="py-12 container mx-auto px-6">
            <h1 className="font-display text-4xl text-center text-emerald-900 mb-12">Simple Pricing</h1>
            
            <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
                {/* Drop In */}
                <div className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100 flex flex-col">
                    <h3 className="font-display text-2xl text-gray-800 mb-2">Drop-in Visit</h3>
                    <p className="text-gray-500 mb-6">Perfect for occasional visits</p>
                    <div className="text-4xl font-bold text-emerald-600 mb-6">R 150<span className="text-base font-normal text-gray-400">/30 min</span></div>
                    
                    <ul className="space-y-4 mb-8 flex-grow">
                        <li className="flex items-center text-gray-700"><Check size={18} className="text-green-500 mr-2"/> Private use of entire park</li>
                        <li className="flex items-center text-gray-700"><Check size={18} className="text-green-500 mr-2"/> Up to 3 dogs included</li>
                        <li className="flex items-center text-gray-700"><Check size={18} className="text-green-500 mr-2"/> Secure parking</li>
                    </ul>
                    
                    <Link to="/app" className="w-full block text-center border-2 border-emerald-600 text-emerald-600 font-bold py-3 rounded-lg hover:bg-emerald-50 transition">
                        Book Single Slot
                    </Link>
                </div>

                {/* Packages */}
                <div className="bg-emerald-900 text-white p-8 rounded-2xl shadow-xl flex flex-col transform md:-translate-y-4">
                    <div className="absolute top-4 right-4 bg-yellow-400 text-yellow-900 text-xs font-bold px-3 py-1 rounded-full">BEST VALUE</div>
                    <h3 className="font-display text-2xl mb-2">Power Pack</h3>
                    <p className="text-emerald-200 mb-6">For the regulars</p>
                    <div className="text-4xl font-bold text-white mb-6">R 1200<span className="text-base font-normal text-emerald-200">/10 slots</span></div>
                    
                    <ul className="space-y-4 mb-8 flex-grow text-emerald-50">
                        <li className="flex items-center"><Check size={18} className="text-yellow-400 mr-2"/> Save R300 immediately</li>
                        <li className="flex items-center"><Check size={18} className="text-yellow-400 mr-2"/> Priority booking</li>
                        <li className="flex items-center"><Check size={18} className="text-yellow-400 mr-2"/> Valid for 3 months</li>
                    </ul>
                    
                    <Link to="/app" className="w-full block text-center bg-yellow-400 text-yellow-900 font-bold py-3 rounded-lg hover:bg-yellow-300 transition">
                        Buy Package
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default Pricing;